module.exports = __webpack_public_path__ + "static/media/3.7f9349bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/3.png
// module id = 1469
// module chunks = 0